import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Plan } from "../models/plan";
import { User } from "../models/user";

@Injectable({
    providedIn: "root"
})
export class SharedService {

    private currentPlan = new BehaviorSubject<Plan>(null);
    public plan$ = this.currentPlan.asObservable();

    private submittedPlan = new BehaviorSubject<Plan>(null);
    public submittedPlan$ = this.submittedPlan.asObservable();

    private user = new BehaviorSubject<User>(null);
    public user$ = this.user.asObservable();

    private planUnderReflection = new BehaviorSubject<string>(null);
    public planUnderReflection$ = this.planUnderReflection.asObservable();

    private plans = new BehaviorSubject<Plan[]>(null);
    public plans$ = this.plans.asObservable();

    updatePlan(plan: Plan){
        if(this.currentPlan.value == null || this.currentPlan.value.Id == plan.Id)
            this.currentPlan.next(plan);
    }

    updateUser(user: User){
        this.user.next(user);
    }

    updateSubmittedPlan(plan: Plan){
        this.submittedPlan.next(plan);
    }

    updatePlanUnderReflection(planId: string){
        this.planUnderReflection.next(planId);
    }

    updatePlans(plans: Plan[]){
        this.plans.next(plans);
    }
}